<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraPromotor />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import LeituraPromotor from "../Components/Leituras/LeituraPromotor.vue";
export default {
  name: "ReadOperator",
  components: {
    LeituraPromotor,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>